<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'edit-template'" :bg-grey="true" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="getTitle" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20 m-t-16" v-if="formReady">
                    <div class="f-regular f-14 f-c-black m-d-16">
                        <p class="m-d-0">
                            Dikirim ke konsumen setelah melakukan transaksi Self Service & Drop Off (Snapbridge).
                        </p>
                        <p class="m-d-0 f-c-blue" @click="gotoPanduan">Lihat panduan penulisan</p>
                    </div>
                    <div class="m-d-16">
                        <SOInputWysiwyg
                            ref="SOInputWysiwyg"
                            :default-content="getMessage"
                            :category="category"
                            :saving-update="doUpdateTemplate"
                            :is-fetching="isFetching"
                        />
                    </div>
                    <div class="m-d-16 f-regular f-14 f-c-black" style="text-align: center;">
                        <p class="m-d-0" v-if="updatedAt">
                            Terakhir diubah {{ $moment(updatedAt).format("D MMM YYYY HH:mm") }}
                        </p>
                        <p class="m-d-0" v-if="createdAt && !updatedAt">
                            Dibuat {{ $moment(createdAt).format("D MMM YYYY HH:mm") }}
                        </p>
                        <p class="m-d-0 f-c-blue" @click="gotoResetTemplate">Reset template</p>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputWysiwyg from "@/so-components/global/input/SOInputWysiwyg.vue";

import { moduleName } from "../../store/state";

export default {
    name: "EditTemplate",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOInputWysiwyg,
    },
    data() {
        return {
            formReady: false,
            category: "",
            idpayload: "wa_nota_reguler",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "wa_autosender.detail_perangkat.daftar_oulet.edit_template") {
                vm.init();
                vm.setFormReady(false);
            }

            if (from.name === "wa_autosender.detail_perangkat.daftar_oulet.edit_template.reset_template") {
                vm.$refs.SOInputWysiwyg.init();
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "wa_autosender.detail_perangkat.daftar_oulet.edit_template.reset_template") {
            this.resetDetailTemplatePesan();
        }
        next();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            detailTemplatePesan: "detailTemplatePesan",
            isFetching: "isFetching",
            response: "response",
        }),
        createdAt() {
            return this.detailTemplatePesan.created_at;
        },
        updatedAt() {
            return this.detailTemplatePesan.updated_at;
        },
        getJenisSetting() {
            return this.$route.query.jenisSetting;
        },
        getMessage() {
            return this.detailTemplatePesan.template;
        },
        newTemplate() {
            return this.$refs.SOInputWysiwyg.newContent;
        },
        getTitle() {
            return this.$route.query.title;
        },
        getIdOutlet() {
            return this.$route.params.id_outlet;
        },
    },
    methods: {
        ...mapActions({
            getDetailTemplatePesan: `${moduleName}/getDetailTemplatePesan`,
            resetDetailTemplatePesan: `${moduleName}/resetDetailTemplatePesan`,
            setFetching: `${moduleName}/setFetching`,
            updateTemplate: `${moduleName}/updateTemplate`,
        }),
        async init() {
            await this.setDataDefault();
            await this.getDetailTemplatePesan({ idoutlet: this.getIdOutlet, idpayload: this.idpayload });
        },
        setDataDefault() {
            switch (this.getJenisSetting) {
                case "transaksi-snap":
                    this.category = "transaksi";
                    this.idpayload = "snap_transaksi_nota";
                    break;
                case "top-up-deposit":
                    this.idpayload = "beli_deposit";
                    this.category = "beli_deposit";
                    break;
                case "top-up-epayment":
                    this.idpayload = "beli_emoney";
                    this.category = "beli_emoney";
                    break;
                case "notif-selesai":
                    this.category = "selesai";
                    this.idpayload = "selesai";
                    break;
                case "notif-pengambilan":
                    this.category = "ambil";
                    this.idpayload = "ambil";
                    break;
                case "bukti-ambil":
                    this.category = "ambil";
                    this.idpayload = "bukti_ambil";
                    break;
				case "pelunasan":
                    this.category = "pelunasan";
                    this.idpayload = "pelunasan";
                    break;
                case "transaksi-reg":
                default:
                    this.idpayload = "transaksi";
                    this.category = "transaksi";
                    break;
            }
        },
        back() {
            let { getMessage, newTemplate, $router } = this;
            if (getMessage === newTemplate) {
                $router.push({
                    name: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
                });
            } else {
                $router.push({
                    name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template.confirm_leave",
                });
            }
        },
        setFormReady(val) {
            this.formReady = val;
        },
        gotoPanduan() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template.panduan",
                query: { title: this.$route.query.title, jenisSetting: this.$route.query.jenisSetting },
            });
        },
        gotoResetTemplate() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template.reset_template",
                query: {
                    title: this.$route.query.title,
                    jenisSetting: this.$route.query.jenisSetting,
                    idpayload: this.idpayload,
                },
            });
        },
        doUpdateTemplate(template) {
            this.updateTemplate({ idpayload: this.idpayload, idoutlet: this.getIdOutlet, template })
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.$toast.success(msg);
                        this.getDetailTemplatePesan({ idoutlet: this.getIdOutlet, idpayload: this.idpayload });
                        this.$router.go(-2);
                    } else {
                        this.$toast.error(msg);
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
<style scoped></style>
